/**
 * Generated runtime TestId mirror for frontend/src/pages/CertificationDashboard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CertificationDashboardTestIds = {
  btnCreateCampaign: "btn-create-campaign",
  btnGenerateCampaigns: "btn-generate-campaigns",
  cardActiveCampaigns: "card-active-campaigns",
  cardActiveCampaignsTable: "card-active-campaigns-table",
  cardCampaignManagement: "card-campaign-management",
  cardDecisionsOverview: "card-decisions-overview",
  cardReviewProgress: "card-review-progress",
  cardTitleActiveCampaigns: "card-title-active-campaigns",
  cardTitleCampaignManagement: "card-title-campaign-management",
  certificationDashboard: "certification-dashboard",
  certificationDashboardSummary: "certification-dashboard-summary",
  colCampaign: "col-campaign",
  colDueDate: "col-due-date",
  colKeep: "col-keep",
  colManagementDueDate: "col-management-due-date",
  colManagementName: "col-management-name",
  colManagementOwner: "col-management-owner",
  colManagementPolicy: "col-management-policy",
  colManagementStatus: "col-management-status",
  colProgress: "col-progress",
  colRevoked: "col-revoked",
  colUndecided: "col-undecided",
  kpiActiveCampaignsValue: "kpi-active-campaigns-value",
  kpiDecisionsOverviewValue: "kpi-decisions-overview-value",
  kpiOverdueBadge: "kpi-overdue-badge",
  kpiReviewProgressValue: "kpi-review-progress-value",
  campaignName: (campaign_id: string) => `campaign-name-${campaign_id}`,
  campaignNamePrefix: () => "campaign-name-" as TestIdPrefix,
  campaignPolicy: (campaign_id: string) => `campaign-policy-${campaign_id}`,
  campaignPolicyPrefix: () => "campaign-policy-" as TestIdPrefix,
  campaignPolicyLink: (campaign_id: string) => `campaign-policy-link-${campaign_id}`,
  campaignPolicyLinkPrefix: () => "campaign-policy-link-" as TestIdPrefix,
  campaignStatus: (campaign_id: string) => `campaign-status-${campaign_id}`,
  campaignStatusPrefix: () => "campaign-status-" as TestIdPrefix,
  dashboardCampaignLink: (campaign_id: string) => `dashboard-campaign-link-${campaign_id}`,
  dashboardCampaignLinkPrefix: () => "dashboard-campaign-link-" as TestIdPrefix,
  dashboardCampaignName: (campaign_id: string) => `dashboard-campaign-name-${campaign_id}`,
  dashboardCampaignNamePrefix: () => "dashboard-campaign-name-" as TestIdPrefix,
  dashboardCampaignProgress: (campaign_id: string) => `dashboard-campaign-progress-${campaign_id}`,
  dashboardCampaignProgressPrefix: () => "dashboard-campaign-progress-" as TestIdPrefix,
  dashboardCampaignRow: (campaign_id: string) => `dashboard-campaign-row-${campaign_id}`,
  dashboardCampaignRowPrefix: () => "dashboard-campaign-row-" as TestIdPrefix,
  linkCampaign: (campaign_id: string) => `link-campaign-${campaign_id}`,
  linkCampaignPrefix: () => "link-campaign-" as TestIdPrefix,
  managementCampaignRow: (campaign_id: string) => `management-campaign-row-${campaign_id}`,
  managementCampaignRowPrefix: () => "management-campaign-row-" as TestIdPrefix
} as const;
